import { render, staticRenderFns } from "./showGiftCard.vue?vue&type=template&id=4a353ee2"
import script from "./showGiftCard.vue?vue&type=script&lang=js"
export * from "./showGiftCard.vue?vue&type=script&lang=js"
import style0 from "./showGiftCard.vue?vue&type=style&index=0&id=4a353ee2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports